import { createSelector } from '@ngrx/store';
import { getGlobalHomeFeatureStore } from '../index';

const getTrendingHashFeature = createSelector(
  getGlobalHomeFeatureStore,
  state => state.trendingHash
);

export const getHashTrends = createSelector(
  getTrendingHashFeature,
  state => state.trending
);
export const getHashTrendsLoading = createSelector(
  getTrendingHashFeature,
  state => state.loading
);
export const getHashTrendsError = createSelector(
  getTrendingHashFeature,
  state => state.error
);
